<!-- 业务管理 -->
<template>
    <div id="business" class="business">
        <div class="user-msg">
            <span class="gotoMenu" v-if="showImDialog && navBtn.nav_qx" @click="updateImDialogStatus(false)">
                <img src="http://publicfiles.chehuijia.com.cn/avatar.png" alt="" />
                <span class="gotoMenu-name">
                    我的企信
                    <span class="read-tip" v-if="noReadMsgCount && noReadMsgCount !== '0'">{{ noReadMsgCount }}</span>
                </span>
            </span>
            <span class="gotoMenu" @click="showEPCDialog" v-if="navBtn.nav_epc">
                <img src="../../assets/images/epc.png" alt="" />
                <span class="gotoMenu-name">CHJ EPC</span>
            </span>
            <span class="gotoMenu" @click="showCheckDialog" v-if="navBtn.nav_cuishou">
                <img src="../../assets/images/check.png" alt="" />
                <el-badge v-if="isPaymentBillIsCheck" is-dot class="item">收款账单</el-badge>
                <span v-else class="gotoMenu-name">收款账单</span>
            </span>
            <span class="gotoMenu" @click="gotoZoneScreen" v-if="navBtn.nav_quyukanBan">
                <img src="../../assets/images/quyukanban.png" alt="" />
                <span class="gotoMenu-name">区域看板</span>
            </span>
            <span class="gotoMenu" @click="gotoAllOrderScreen" v-if="navBtn.nav_sOkanBan">
                <img src="../../assets/images/sokanban.png" alt="" />
                <span class="gotoMenu-name">订单总看板</span>
            </span>
            <span class="gotoMenu" @click="gotoScreen" v-if="navBtn.nav_kanBan">
                <img src="../../assets/images/screen.png" alt="" />
                <span class="gotoMenu-name">发货看板</span>
            </span>
            <span class="gotoMenu" @click="createShortcutDialog = true" v-if="navBtn.nav_addShortcut">
                <img src="../../assets/images/computer.png" alt="" />
                <span class="gotoMenu-name">添加桌面快捷方式</span>
            </span>
            <span class="gotoMenu" @click="gotoTutorial" v-if="navBtn.nav_tutorial">
                <img src="../../assets/images/teach.png" alt="" />
                <span class="gotoMenu-name">教程说明</span>
            </span>
            <el-dropdown trigger="click" class="loginCenter">
                <span class="el-dropdown-link">
                    <span style="font-size: 16px">{{ userMsg.Account }}</span>
                    <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown" style="width: 150px">
                    <el-dropdown-item>
                        <span @click="gotoMessage" class="loginOut-btn">我的消息</span>
                    </el-dropdown-item>
                    <el-dropdown-item v-if="navBtn.nav_setInfos">
                        <span @click="gotoBase" class="loginOut-btn">
                            {{ navBtn.nav_setInfos }}
                        </span>
                    </el-dropdown-item>
                    <el-dropdown-item v-if="navBtn.nav_shopCar">
                        <span @click="gotoShopCar" class="loginOut-btn">
                            {{ navBtn.nav_shopCar }}
                        </span>
                    </el-dropdown-item>
                    <el-dropdown-item v-if="navBtn.nav_myOrders">
                        <span @click="gotoShopOrder" class="loginOut-btn">
                            {{ navBtn.nav_myOrders }}
                        </span>
                    </el-dropdown-item>
                    <el-dropdown-item v-if="navBtn.nav_clearData">
                        <span @click="showClearDialog" class="loginOut-btn">
                            {{ navBtn.nav_clearData }}
                        </span>
                    </el-dropdown-item>
                    <el-dropdown-item v-if="navBtn.nav_updatePwd">
                        <span @click="showForget" class="loginOut-btn">
                            {{ navBtn.nav_updatePwd }}
                        </span>
                    </el-dropdown-item>
                    <el-dropdown-item v-if="navBtn.nav_updateAuth && !isShowUnionNav">
                        <span @click="updateAuth" class="loginOut-btn">
                            {{ navBtn.nav_updateAuth }}
                        </span>
                    </el-dropdown-item>
                    <el-dropdown-item v-if="isShowUnionNav">
                        <span @click="updateUnionAuth" class="loginOut-btn">更新联盟权限</span>
                    </el-dropdown-item>
                    <el-dropdown-item>
                        <span @click="updatePrintModels" class="loginOut-btn">更新打印模板</span>
                    </el-dropdown-item>
                    <el-dropdown-item>
                        <span @click="logout" class="loginOut-btn">退出登录</span>
                    </el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
        <el-menu v-if="isShowHeadNav" :default-active="bsactiveIndex" mode="horizontal" text-color="#fff" background-color="#8c98cc" active-text-color="#fff">
            <el-menu-item v-for="item in menu" :index="item.originUrl" class="nav-lv2" :key="item.Id" @click="menuHandle(item)">
                <router-link :to="item.Url">{{ item.Name }}</router-link>
            </el-menu-item>
        </el-menu>
        <el-menu v-if="isShowUnionNav" :default-active="bsactiveIndex" mode="horizontal" text-color="#fff" background-color="#8c98cc" active-text-color="#fff">
            <el-menu-item v-for="item in unionMenu" :index="item.originUrl" class="nav-lv2" :key="item.Id" @click="menuHandle(item)">
                <router-link :to="item.Url">{{ item.Name }}</router-link>
            </el-menu-item>
        </el-menu>
        <router-view></router-view>
        <el-dialog title="忘记密码" :close-on-click-modal="false" :before-close="clearDialog" :visible.sync="dialogVisible" width="500">
            <div class="dialog-content">
                <forgetPwd ref="forgetPwd" @clearDialog="clearDialog"></forgetPwd>
            </div>
        </el-dialog>
        <el-dialog
            :close-on-click-modal="false"
            title="初始化数据"
            @close="closeClearDialog"
            :visible.sync="clearDialogVisible"
            append-to-body
            modal-append-to-body
            :show-close="false"
            width="600px"
        >
            <div class="dialog-content" v-if="clearDialogVisible">
                <ClearDatas ref="clearDatas" @closeDialog="closeClearDialog"></ClearDatas>
            </div>
        </el-dialog>
        <el-dialog title="添加桌面快捷方式" :visible.sync="createShortcutDialog" width="500px" class="shortcut">
            <el-container class="container">
                <el-header class="header">
                    <span>将下载的"车回佳"快捷登录方式，解压缩到桌面即可。</span>
                </el-header>
                <el-main>
                    <div class="mainDiv">
                        <div class="desktop">
                            <img src="../../assets/images/desktop.png" />
                            <img class="floatImg" src="../../assets/images/logo.png" style="width: 20px" />
                        </div>
                        <div class="arrowLeft">
                            <img src="../../assets/images/arrow-left.png" />
                        </div>
                        <div class="chjlogo">
                            <img src="../../assets/images/logo-144.png" />
                        </div>
                    </div>
                </el-main>
                <el-footer style="text-align: center">
                    <el-button size="small" class="btn-primary" @click="createShortcut">下载</el-button>
                </el-footer>
            </el-container>
        </el-dialog>
        <el-dialog
            title="车回佳 EPC"
            :close-on-click-modal="false"
            :visible.sync="isShowEPC"
            append-to-body
            v-dialog-drag
            lock-scroll
            :modal="false"
            id="epc-dialog"
            style="margin-left: -600px"
            width="1300px"
        >
            <div v-if="isShowEPC">
                <EpcAutoBrands :visible="isShowEPC"></EpcAutoBrands>
            </div>
        </el-dialog>
        <el-dialog
            title="收款账单"
            :close-on-click-modal="false"
            :visible.sync="isShowCheck"
            append-to-body
            v-dialog-drag
            lock-scroll
            :modal="false"
            id="epc-dialog"
            style="margin-left: -300px"
            width="660px"
        >
            <div v-if="isShowCheck">
                <DemandPayment :visible="isShowCheck" ref="DemandPayment" v-on:IsCheckBillIs="IsCheckBillIs"></DemandPayment>
            </div>
        </el-dialog>
        <el-dialog
            title="详细图片"
            :close-on-click-modal="false"
            :visible.sync="isShowImg"
            append-to-body
            v-dialog-drag
            lock-scroll
            :modal="false"
            id="epc-dialog"
            style="margin-left: -500px"
            :width="imgwidth"
        >
            <div v-if="isShowImg" class="img-body">
                <img :src="billsImg" />
            </div>
        </el-dialog>
        <top-nav></top-nav>
        <preOrderBar ref="preOrder"></preOrderBar>
    </div>
</template>
<script>
import forgetPwd from '@/components/common/forgetPwd.vue';
import ClearDatas from '@/components/common/clearDatas.vue';
import topNav from '@/components/common/topNav.vue';
import EpcAutoBrands from '@/components/common/epc_autoBrands';
import DemandPayment from '@/components/common/demandPayment';
import preOrderBar from '@/components/common/preOrderBar';
import mixin from '@/mixins/mixin';
export default {
    mixins: [mixin],
    name: 'business',
    components: {
        forgetPwd,
        topNav,
        ClearDatas,
        EpcAutoBrands,
        preOrderBar,
        DemandPayment
    },
    data() {
        let userMsg = this.$util.getLocalStorage('userMsg');
        return {
            createShortcutDialog: false,
            window: window,
            navBtn: {},
            menu: {},
            unionMenu: {},
            dialogVisible: false,
            showCarContent: false,
            userMsg: userMsg,
            EntpName: '',
            nav: [],
            sId: '',
            showImDialog: this.$util.getLocalStorage('showImDialog'),
            noReadMsgCount: '',
            layim: null,
            clearDialogVisible: false,
            isShowEPC: false,
            isShowCheck: false,
            isPaymentBillIsCheck: false,
            isShowImg: false,
            billsImg: '',
            imgwidth: '1200px'
        };
    },
    mounted() {
        this.$nextTick(() => {
            this.readUserMsg();
        });

        this.$util.getTree().then(() => {
            this.navBtn = this.$util.getPermission('NavFuncBtn');
            this.menu = this.$util.getAcrossNavNode('ctn', 1);

            if (this.navBtn.nav_qx) {
                //最后再初始化IM
                this.getUserIMData();

                this.$util.getNoReadMsgCount().then(data => {
                    this.noReadMsgCount = data;
                });
            }
        });
        this.checkPreShow();
        this.checkEntpPaymentBillIs();
    },
    computed: {
        getAskPJMsg() {
            return this.$store.getters.askPJMsg;
        },
        getAskGoods() {
            return this.$store.getters.askGoods;
        },
        getAskShareGoods() {
            return this.$store.getters.askShareGoods;
        },
        bsactiveIndex() {
            return this.$route.matched[1].path;
        },
        needUpdateNum() {
            return this.$store.state.messageNum;
        },
        isShowHeadNav() {
            if (this.$route.matched[1].path != '/' && this.$route.matched[1].path.indexOf('/entpUnion') == -1) {
                return true;
            } else return false;
        },
        isShowUnionNav() {
            if (this.$route.matched[1].path.indexOf('/entpUnion') > -1) {
                this.getUnionMenuModules();
                return true;
            } else return false;
        },
        connectState() {
            return this.$store.state.connectState;
        },
        getGroupMsg() {
            return this.$store.state.groupMsg;
        },
        getNewUnionPer() {
            return this.$store.state.reflashUnion;
        },
        getShowPreOrder() {
            return this.$store.state.showPreOrder;
        }
    },
    watch: {
        // 拿到推送配件信息
        getAskPJMsg(value) {
            let that = this;
            if (that.sId) {
                that.$socket.sendProductToServiceWebsocket(
                    {
                        contentType: 2,
                        content: JSON.stringify(value),
                        sId: that.sId,
                        ObjectId: value.Id
                    },
                    res => {}
                );
            } else that.$util.warningMsg('暂未分配到相关客服，请联系车回佳技术人员');
        },
        // 拿到推送商城商品
        getAskGoods(value) {
            let that = this;
            if (that.sId) {
                let _content = {
                    Cn: value.Name,
                    Code: value.GoodsCode,
                    PublicUrl: value.PictureVideoList[0] ? value.PictureVideoList[0].Url : '',
                    Id: value.GoodsId,
                    Price: value.ShopPrice
                };
                that.$socket.sendProductToServiceWebsocket(
                    {
                        contentType: 6,
                        content: JSON.stringify(_content),
                        sId: that.sId,
                        ObjectId: _content.GoodsId
                    },
                    res => {}
                );
            } else that.$util.warningMsg('暂未分配到相关客服，请联系车回佳技术人员');
        },
        // 拿到推送网销商品
        getAskShareGoods(value) {
            let that = this;
            if (that.sId) {
                let _content = {
                    Cn: value.GoodsName,
                    Code: value.APCode,
                    PublicUrl: value.MainImg ? value.MainImg : value.PictureList[0].Url,
                    Id: value.Id ? value.Id : value.GoodsId,
                    Price: value.SharePrice
                };
                that.$socket.sendProductToServiceWebsocket(
                    {
                        contentType: 12,
                        content: JSON.stringify(_content),
                        sId: that.sId,
                        ObjectId: _content.GoodsId
                    },
                    res => {}
                );
            } else that.$util.warningMsg('暂未分配到相关客服，请联系车回佳技术人员');
        },
        //监听websocket断开状态，更改layim.online的登录效果
        connectState(value) {
            let layimStatus = document.getElementsByName('layimStatus')[0];
            let layTypeOnline = document.getElementsByName('layTypeOnline')[0];
            let layTypeHide = document.getElementsByName('layTypeHide')[0];
            //只有在断线时触发
            if (layimStatus && value === 0) {
                layimStatus.className = `layui-icon layim-status-hide`;
                if (layTypeOnline && layTypeHide) {
                    layTypeOnline.className = '';
                    layTypeHide.className = 'layim-this';
                }
            } else if (value === 3) {
                this.getUserIMData();
            }
        },
        getGroupMsg(value) {
            let that = this;
            if (value) {
                that.receiveGroupChat(value);
            }
        },
        getNewUnionPer(value) {
            if (value) {
                this.getUnionMenuModules();
            }
        },
        getShowPreOrder(value) {
            this.checkPreShow(value);
        }
    },
    methods: {
        menuHandle(row) {
            if (row.Name) {
                document.title = row.Name;
            } else {
                document.title = '车回佳企业客户端管理系统';
            }
        },
        //当跳转至联盟的时候，需要更新
        getUnionMenuModules() {
            this.unionMenu = this.$util.getAcrossUnionNavNode('ctn_union', 1);
        },
        clearDialog() {
            this.$refs.forgetPwd.resetForm();
            this.dialogVisible = false;
        },
        showForget() {
            this.dialogVisible = true;
        },
        showClearDialog() {
            this.clearDialogVisible = true;
        },
        closeClearDialog() {
            this.clearDialogVisible = false;
        },
        // 跳转购物车
        gotoShopCar() {
            this.$router.push('/shop/buycar');
        },
        gotoShopOrder() {
            this.$router.push('/shop/shopOrder');
        },
        gotoTutorial() {
            this.$router.push('/tutorial/videoIndex');
        },
        gotoZoneScreen() {
            let routrUrl = this.$router.resolve({
                path: '/zoneOrder'
            });
            window.open(routrUrl.href, '_blank');
        },
        gotoAllOrderScreen() {
            let routrUrl = this.$router.resolve({
                path: '/allOrder'
            });
            window.open(routrUrl.href, '_blank');
        },
        gotoScreen() {
            let routrUrl = this.$router.resolve({
                path: '/screen'
            });
            window.open(routrUrl.href, '_blank');
        },
        // 跳转信息设置
        gotoBase() {
            this.$router.push('/msgSetting/companyMsg');
        },
        // 跳转到消息列表
        gotoMessage() {
            this.$router.push('/message');
        },
        // 注销
        logout() {
            this.$util
                .axiosPost({
                    url: '/api/Login/EntpLogout',
                    data: `token=${this.$util.getCookie('Token')}`
                })
                .then(res => {
                    if (res.data) {
                        //断开socket
                        try {
                            this.$socket.closeSocket();
                        } catch {
                            //
                        }
                        this.$util.clearLoginedData();
                        if (this.$util.CHJWinApp) window.location.href = `chjscheme:${encodeURIComponent('logout')}`;
                        this.$router.push('/login');
                    }
                })
                .catch(() => {});
        },
        // 读取用户信息
        readUserMsg() {
            let _userMsg = this.$util.getLocalStorage('userMsg');
            this.userMsg = _userMsg;
            this.EntpName = _userMsg.EntpName;
            let Token = this.$util.getCookie('Token');
            if (!Token) {
                this.$util.warningMsg('请先登录');
                setTimeout(() => {
                    this.$router.push('/login');
                }, 2000);
            }
        },
        initLayUI(res) {
            let that = this;
            let data = res;
            that.sId = data.sId;

            layui.use('layim', function (layim) {
                that.layim = layui.layim;
                var cache = layui.layim.cache();
                // 函数：接收WebSocket消息
                var receiveWebsocketFunc = massage => {
                    if (massage.type == 'onConnect') {
                        //设置客服在线
                        if (massage.result.cs_Online && massage.result.sId) layim.setFriendStatus(massage.result.sId + '-service', 'online');
                    } else if (massage.type == 'onConnect-Stuff') {
                        if (massage.result.connState == 0) layim.setFriendStatus(massage.result.cId, 'online');
                        else if (massage.result.connState == 1) layim.setFriendStatus(massage.result.cId, 'offline');
                    } else if (massage.type == 'ReceiveMsg') {
                        let msgData = {
                            id: massage.result.sender + '-service',
                            avatar: massage.result.avatarUrl,
                            cid: massage.result.id,
                            fromid: massage.result.sender + '-service',
                            mine: false,
                            type: 'friend',
                            timestamp: massage.result.timestamp,
                            username: massage.result.name,
                            content: ''
                        };

                        let _content = {};
                        let newContent = {};
                        let uId = that.$util.getLocalStorage('userMsg').EmployeeId;
                        switch (massage.result.contentType) {
                            case 0: // 文字
                                msgData.content = massage.result.content;
                                break;
                            case 1: // 图片
                                msgData.content = 'img[' + that.$util.QN_URL_BASE + massage.result.content + ']';
                                break;
                            case 2: // 汽配件
                                if (massage.result.sender == that.uId) {
                                    msgData.id = that.sId + '-service';
                                    msgData.mine = true;
                                    msgData.fromid = that.uId + '-stuff';
                                }
                                //重新包装内容
                                _content = JSON.parse(massage.result.content);
                                newContent = {
                                    id: _content.Id,
                                    code: _content.Code,
                                    name: _content.Cn,
                                    url: that.$util.QN_URL_BASE + _content.PublicUrl,
                                    type: 2
                                };
                                msgData.content = 'product[' + JSON.stringify(newContent) + ']';
                                break;
                            case 5: // 临时商品
                                break;
                            case 6: // 商城商品
                                if (massage.result.sender == that.uId) {
                                    msgData.id = that.sId + '-service';
                                    msgData.mine = true;
                                    msgData.fromid = that.uId + '-stuff';
                                }
                                //重新包装内容
                                _content = JSON.parse(massage.result.content);
                                newContent = {
                                    id: _content.Id,
                                    code: _content.Code,
                                    name: _content.Cn,
                                    url: that.$util.QN_URL_BASE + _content.PublicUrl,
                                    type: 6,
                                    price: _content.Price
                                };
                                msgData.content = 'product[' + JSON.stringify(newContent) + ']';
                                break;
                            case 11: // 视频
                                break;
                            case 12: // 共享（网销）商品
                                if (massage.result.sender == that.uId) {
                                    msgData.id = that.sId + '-service';
                                    msgData.mine = true;
                                    msgData.fromid = that.uId + '-stuff';
                                }
                                //重新包装内容
                                _content = JSON.parse(massage.result.content);
                                newContent = {
                                    id: _content.Id,
                                    code: _content.Code,
                                    name: _content.Cn,
                                    url: that.$util.QN_URL_BASE + _content.PublicUrl,
                                    type: 12,
                                    price: _content.Price
                                };
                                msgData.content = 'product[' + JSON.stringify(newContent) + ']';
                                break;
                            default:
                                return;
                        }

                        layim.getMessage(msgData);

                        let thisChat = layim.thisChat();
                        if (thisChat && thisChat.data)
                            if (thisChat.data.id == msgData.id)
                                //设置已读
                                that.$socket.markRead(that.currentChatId);
                    }
                };
                //基础配置
                layim.config({
                    //初始化接口
                    init: {
                        mine: data.mine,
                        friend: data.friend,
                        group: data.group
                    },

                    title: '我的企信', //自定义主面板最小化时的标题
                    initSkin: data.skinImg, //1-5 设置初始背景
                    skin: [], //新增皮肤
                    isfriend: true, //是否开启好友
                    isgroup: true, //是否开启群组，要改成企业客户
                    notice: true, //是否开启桌面消息提醒，默认false
                    voice: false, //声音提醒，默认开启，声音文件为：default.mp3

                    msgbox: layui.cache.dir + 'css/modules/layim/html/msgbox.html', //消息盒子页面地址，若不开启，剔除该项即可
                    find: layui.cache.dir + 'css/modules/layim/html/find.html', //发现页面地址，若不开启，剔除该项即可
                    chatLog: layui.cache.dir + 'css/modules/layim/html/chatlog.html', //聊天记录页面地址，若不开启，剔除该项即可
                    //查看群员接口
                    members: {
                        url: that.$util.BASE_URL + '/Notification/GetEntpGroupMembers',
                        data: { entpId: that.userMsg.EntpId }
                    },

                    //上传图片接口
                    uploadImage: {
                        url: that.$util.BASE_URL + '/UploadFile/UploadSingle', //（返回的数据格式见下文）
                        type: 'images', //默认post
                        token: that.userMsg.Token
                    },

                    //上传文件接口
                    uploadFile: {
                        url: that.$util.BASE_URL + '/UploadFile/UploadSingle', //（返回的数据格式见下文）
                        type: 'file', //默认post
                        token: that.userMsg.Token
                    }
                });

                //获取未读消息，初始化的时候要通知
                that.getUnreadMsg().then(data => {
                    data.forEach(item => {
                        layim.getMessage(item);
                    });
                });

                that.getGroupUnreadMsg().then(data => {
                    data.forEach(item => {
                        layim.getMessage(item);
                    });
                });

                that.$socket.receivePersonalChat(massage => {
                    //自己发的没必要再展示一遍
                    if (massage.result.fromid != cache.mine.id) layim.getMessage(massage.result);
                });

                //接受群的消息
                // that.$socket.receiveGroupChat((massage) => {
                //   let fromid = "";
                //   if (massage.result.fromid) fromid = massage.result.fromid;
                //   if (massage.result.customer)
                //     layim.getMessage({
                //       name: massage.result.name,
                //       avatar: massage.result.customer.avatarUrl,
                //       id: massage.result.id,
                //       type: "group",
                //       content: massage.result.content,
                //       username: massage.result.customer.uName,
                //       fromid: fromid,
                //     });
                // });

                that.$socket.receiveSystemMsg(massage => {
                    if (massage.result.level == 1) {
                        that.$notify.info({
                            title: massage.result.title,
                            message: massage.result.content,
                            position: 'bottom-left',
                            duration: 10000
                        });
                    } else if (massage.result.level == 2) {
                        that.$notify.info({
                            title: massage.result.title,
                            message: h('i', { style: 'color: red' }, massage.result.content),
                            position: 'bottom-left',
                            duration: 0,
                            type: 'warning'
                        });
                    } else if (massage.result.level == 3) {
                        that.$notify({
                            title: massage.result.title,
                            dangerouslyUseHTMLString: true,
                            message: massage.result.content + '<strong id="out" style="color:red;">10</strong>s后将自动退出',
                            position: 'bottom-left',
                            duration: 10000,
                            type: 'warning',
                            onClose() {
                                that.logout();
                            }
                        });
                        var i = 9;
                        var out = document.getElementById('out');
                        var timer = setInterval(function () {
                            if (i == -1) {
                                clearInterval(timer);
                            } else {
                                out.innerHTML = i;
                                --i;
                            }
                        }, 1000);
                    } else {
                        that.$notify.info({
                            title: massage.result.title,
                            message: massage.result.content,
                            position: 'bottom-left'
                        });
                    }
                });

                that.$socket.receiveWebsocket(massage => {
                    receiveWebsocketFunc(massage);
                });

                try {
                    //当缩小的时候， id = remindmsgcount 给这个消息做一个外部的提醒
                    var msgcount = document.getElementById('remindmsgcount');
                    if (data.noReadMsgCount && data.noReadMsgCount > 0) {
                        msgcount.innerHTML = data.noReadMsgCount;
                        msgcount.setAttribute('class', 'im-msgcount');
                        //设置消息提醒
                        layim.msgbox(data.noReadMsgCount);
                    }
                } catch {
                    //当不是缩小的时候，只需要设置消息提醒
                    layim.msgbox(data.noReadMsgCount);
                }

                //监听在线状态的切换事件
                layim.on('online', function (data) {
                    let connectState = that.$store.state.connectState;
                    if (data == 'online' && connectState != 2) {
                        // that.$socket.initWebSocket();
                        // // 重新加载receiveWebsocket
                        // that.$socket.receiveWebsocket((massage) => {
                        //   receiveWebsocketFunc(massage);
                        // });
                        //需要重新绑定所有的关于socket的事件，否则没法重新被回调
                        that.getUserIMData();
                    } else if (data == 'hide' && connectState == 2) that.$socket.closeSocket();
                });

                //监听签名修改
                layim.on('sign', function (value) {
                    that.changeIMSign(value);
                });

                layim.on('setSkin', function (filename, src) {
                    that.changeIMBackground(filename);
                });

                //监听发送消息
                layim.on('sendMessage', function (data) {
                    //需要确认发的是企业客服，还是公司员工
                    let To = data.to;
                    if (To.type === 'friend') {
                        if (that.currentChatType == 0) {
                            that.$socket.sendToFriendWebsocket(
                                {
                                    contentType: 0,
                                    content: data.mine.content,
                                    sId: that.currentChatId,
                                    sendData: data
                                },
                                res => {
                                    // if (res.errcode == 0) {
                                    //
                                    // }
                                }
                            );
                        } else if (that.currentChatType == 1) {
                            //文本 0；图片 1；
                            if (data.mine.content.indexOf('img[', 0) > -1) {
                                that.$socket.sendToServiceWebsocket(
                                    {
                                        contentType: 1,
                                        content: data.mine.content.replace(/img\[([^\s]+?)\]/g, function (img) {
                                            //转义图片
                                            return img.replace(/(^img\[)|(\]$)/g, '').replace('http://publicfiles.chehuijia.com.cn/', '');
                                        }),
                                        sId: that.currentChatId
                                    },
                                    res => {
                                        // if (res.errcode == 0) {
                                        //
                                        // }
                                    }
                                );
                            } else {
                                that.$socket.sendToServiceWebsocket(
                                    {
                                        contentType: 0,
                                        content: data.mine.content,
                                        sId: that.currentChatId
                                    },
                                    res => {
                                        // if (res.errcode == 0) {
                                        //
                                        // }
                                    }
                                );
                            }
                        }
                    } else {
                        //群聊 -- 企业好友
                        let content = data.mine.content;
                        let contentType = 0;
                        if (content.indexOf('img[') > -1 || content.indexOf('file[') > -1) contentType = 1;

                        that.$socket.sendToEntpFriendWebsocket(
                            {
                                contentType: contentType,
                                content: content,
                                sendData: data
                            },
                            res => {
                                // if (res.errcode == 0) {
                                //
                                // }
                            }
                        );
                    }
                });

                //监听查看群员
                layim.on('members', function () {});

                //监听聊天窗口的切换
                layim.on('chatChange', function (res) {
                    let type = res.data.type;
                    let idstr = res.data.id;
                    if (type) {
                        if (type === 'friend') {
                            //模拟标注好友状态 --- 这个状态有问题
                            // if (res.data.status == "online")
                            //   layim.setChatStatus('<span style="color:#FF5722;">在线</span>');
                            // else if (res.data.status == "offline")
                            //   layim.setChatStatus('<span style="color:grey;">离线</span>');

                            let start = 0;
                            if (idstr.indexOf('-stuff') > 0) {
                                start = idstr.indexOf('-stuff');
                                that.currentChatType = 0;
                                that.$socket.markFriendRead(idstr.substring(0, start));
                            } else if (idstr.indexOf('-service') > 0) {
                                start = idstr.indexOf('-service');
                                that.currentChatType = 1;
                                //设置已读
                                that.$socket.markRead(idstr.substring(0, start));
                            }
                            that.currentChatId = idstr.substring(0, start);
                        } else if (type === 'group') {
                            that.$socket.markGroupRead(idstr);
                            //模拟系统消息
                            // layim.getMessage({
                            //   system: true,
                            //   id: res.data.id,
                            //   type: "group",
                            //   content: "模拟群员" + ((Math.random() * 100) | 0) + "加入群聊"
                            // });
                        }
                    }
                });

                // 是否展示im弹框
                if (that.showImDialog) {
                    let dialogIM = document.querySelectorAll('.layui-layer')[0];
                    if (dialogIM) dialogIM.style.display = 'none';
                }
                that.insertIMHidden();
            });
        },
        receiveGroupChat(massage) {
            let that = this;
            if (that.layim) {
                let fromid = '';
                if (massage.result.fromid) fromid = massage.result.fromid;
                if (massage.result.customer) {
                    that.layim.getMessage({
                        name: massage.result.name,
                        avatar: massage.result.customer.avatarUrl,
                        id: massage.result.id,
                        type: 'group',
                        content: massage.result.content,
                        username: massage.result.customer.uName,
                        fromid: fromid
                    });
                    that.$socket.markGroupRead(massage.result.id);
                }
            } else {
                that.getUserIMData();
            }
        },
        //获取用户的个人及好友
        getUserIMData() {
            this.$util.getUserIMData().then(res => {
                this.$socket
                    .initWebSocket()
                    .then(() => {
                        this.$store.commit('updateConnectState', 2);

                        this.initLayUI(res);
                    })
                    .catch(() => {});
            });
        },
        changeIMSign(data) {
            if (data) {
                this.$util
                    .axiosPost({
                        url: '/api/EntpInfoManagement/ChangeIMSign',
                        data: {
                            Content: data
                        }
                    })
                    .then(() => {});
            }
        },
        checkEntpPaymentBillIs() {
            this.$util
                .axiosGet({
                    url: '/api/IFS/CheckEntpPaymentBillIs'
                })
                .then(res => {
                    if (res.errcode == 0) this.isPaymentBillIsCheck = res.data;
                });
        },
        changeIMBackground(data) {
            if (data) {
                this.$util
                    .axiosPost({
                        url: '/api/EntpInfoManagement/ChangeIMBackground',
                        data: {
                            Content: data
                        }
                    })
                    .then(() => {});
            }
        },
        //获取未读的消息，如果当前窗口打开，就推送消息，如果未打开，就要进行通知，如果是在线状态，不需要推送未读消息
        getUnreadMsg() {
            return new Promise(resolve => {
                this.$util
                    .axiosGet({
                        url: '/api/EntpInfoManagement/GetChatLogByUIdAndShow',
                        hideLoading: true
                    })
                    .then(res => {
                        let data = res.data;
                        if (data != null) {
                            resolve(data);
                        }
                    })
                    .catch(() => {});
            });
        },
        getGroupUnreadMsg() {
            return new Promise(resolve => {
                this.$util
                    .axiosGet({
                        url: '/api/EntpInfoManagement/GetGroupChatLogByUIdAndShow',
                        hideLoading: true
                    })
                    .then(res => {
                        let data = res.data;
                        if (data != null) {
                            resolve(data);
                        }
                    })
                    .catch(() => {});
            });
        },
        // 创建快捷方式
        createShortcut() {
            // this.$util.exportFile({
            //   url: "/api/Login/ShortCut"
            // });
            let a = document.createElement('a');
            a.href = `http://entp.chehuijia.com.cn/download/车回佳.rar`; // 这里的请求方式为get，如果需要认证，接口上需要带上token
            a.click();
        },
        // 在Im中插入隐藏按钮
        insertIMHidden() {
            let dialogIMMain = document.querySelectorAll('.layui-layer .layui-layim-main')[0];
            if (!dialogIMMain) return;
            let hasBtn = dialogIMMain.querySelector('.special-hidden');
            if (hasBtn) return;
            let div = document.createElement('img');
            div.className = 'special-hidden';
            div.src =
                'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAclBMVEUAAABWVlZWVlZVVVVWVlZWVlZWVlZWVlZWVlZWVlZWVlZVVVVXV1dUVFRXV1dSUlJWVlZWVlZWVlZWVlZXV1dYWFhWVlZYWFhWVlZWVlZWVlZWVlZVVVVWVlZWVlZXV1dWVlZXV1dXV1dTU1NVVVVVVVX5oci5AAAAJnRSTlMA/tGt8ebEv1ixnmNSQC8Jr5WGeko1KiDg2oyLcmhEPLVeTyUbDyTOOrEAAACISURBVBjTlY5JFoQgFAPzQSZBcGjF2R7vf8UGPYG1yass8oK7PKorDCsK1ngstGWvia9Oz2qXo8suZA9Um++otD655AFQY2/I+okBLX0BbXahPmmsWFIRga6k11sDh2gB/gzHxGKtgGAkgF+T1oKtgF4KJAYlLJ+1WznVpxMfXJOPldfLqHGTP29zBmqmalbDAAAAAElFTkSuQmCC';
            div.title = '隐藏企信';
            div.addEventListener('click', () => {
                this.updateImDialogStatus(true);
            });
            dialogIMMain.appendChild(div);
        },
        // 是否显示Im弹框
        updateImDialogStatus(value) {
            let dialogIM = document.querySelectorAll('.layui-layer')[0];
            if (dialogIM) {
                dialogIM.style.display = value ? 'none' : 'block';
                this.showImDialog = value;
                if (!value) this.noReadMsgCount = '';
                this.$util.setLocalStorage('showImDialog', value);
            }
        },
        updateAuth() {
            this.$util.updateRoot().then(() => {
                this.$router.go(0);
            });
        },
        updateUnionAuth() {
            this.$util.updateUnionRoot().then(() => {
                this.$router.go(0);
            });
        },
        updatePrintModels() {
            let that = this;
            that.$util.getEntpAllPrintModels(false).then(() => {
                that.$util.successMsg('成功更新打印模板缓存');
                this.$router.go(0);
            });
        },
        showEPCDialog() {
            this.isShowEPC = true;
        },
        showCheckDialog() {
            this.isShowCheck = true;
        },
        async IsCheckBillIs(data) {
            //所有催账已阅
            if (data.type == 0) {
                this.isPaymentBillIsCheck = data.data;
            } else {
                var width = await this.getImgSize(data.data);
                this.imgwidth = width == 0 ? '600px' : width + 50 + 'px';
                this.isShowImg = true;
                this.billsImg = data.data;
            }
        },
        getImgSize(url) {
            var imgObj = new Image();
            imgObj.src = url;
            return imgObj.width;
        },
        checkPreShow(length) {
            // console.log('checkPreShow = ' + length)
            if (length) {
                if (length > 0) {
                    this.$refs.preOrder.showPreOrder();
                } else {
                    this.$refs.preOrder.closePreOrder();
                }
            } else {
                let data = this.$util.getLocalStorage('preOrderGoodsList');
                if (data && data.length > 0) {
                    this.$refs.preOrder.showPreOrder();
                } else {
                    this.$refs.preOrder.closePreOrder();
                }
            }
        }
    }
};
</script>
<style lang="less">
.shop-car-btn-125 {
    .buy-car-content {
        top: 100% !important;
        left: 100% !important;
        bottom: 0;
    }
}
.msg-prompt {
    position: relative;
    display: inline-block;
    cursor: pointer;
    img {
        width: 24px;
        height: 24px;
        margin-right: 20px;
    }
    .num {
        color: white;
        position: absolute;
        top: -5px;
        right: 10px;
        display: inline-block;
        width: 20px;
        height: 20px;
        text-align: center;
        line-height: 20px;
        font-size: 12px;
        border-radius: 50%;
        background: red;
    }
}
.loginCenter {
    cursor: pointer;
    display: flex;
    align-items: center;
}
.nav-lv2 {
    height: 36px !important;
    line-height: 36px !important;
    padding: 0;
    a {
        display: inline-block;
        width: 100%;
        height: 100%;
        padding: 0 20px;
    }
}
.el-menu--horizontal > .nav-lv2.is-active {
    background: #409eff !important;
    border-bottom: none !important;
}
.user-msg {
    font-size: @font-sm;
    position: absolute;
    right: 7px;
    top: -36px;
    display: flex;
}
.EntpName {
    color: white;
    position: absolute;
    left: 152px;
    top: -45px;
    font-size: @font-md;
}
.el-dropdown-menu__item {
    padding: 0 !important;
}
.shortcut {
    .container {
        height: auto;
    }
    .header {
        display: flex;
        align-items: center;
        text-align: center;
        justify-content: center;
        span {
            color: black;
            font-weight: bold;
        }
    }
    .mainDiv {
        width: auto;
        height: auto;
        display: flex;
        justify-content: space-between;
        .desktop {
            width: 140px;
            display: flex;
            align-items: center;
            text-align: center;
            justify-content: center;
            img {
                width: 90px;
            }
        }
        .floatImg {
            position: relative;
            top: -20px;
            right: 75px;
        }
        .arrowLeft {
            display: flex;
            align-items: center;
            text-align: center;
            justify-content: center;
            img {
                width: 50px;
            }
        }
        .chjlogo {
            width: 140px;
            display: flex;
            align-items: center;
            text-align: center;
            justify-content: center;
            img {
                width: 80px;
            }
        }
    }
}
.special-hidden {
    position: absolute;
    top: 2px;
    right: 42px;
    width: 16px;
    height: 16px;
    cursor: pointer;
}
.read-tip {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    top: -9px;
    right: -17px;
    padding: 2px 4px;
    height: 16px;
    min-width: 16px;
    border-radius: 12px;
    color: #fff;
    background-color: #f00;
}
.loginOut-btn {
    width: 100px;
}
#epc-dialog {
    position: absolute;
    top: 0;
    left: 50%;
    right: auto;
    bottom: auto;
    width: 10px;
    height: 10px;
    overflow: visible;

    .el-dialog {
        box-shadow: 0 0 9px 3px #999;
    }

    .el-dialog__body {
        height: calc(100% - 54px);
        overflow: auto;
    }
}
</style>
<style lang="less" scoped>
.item {
    color: white;
}
.img-body {
    display: flex;
    justify-content: center;
    align-items: center;
    max-height: 600px;
    overflow: auto;
}
</style>
<style>
.el-badge__content {
    border: none;
}
.el-badge__content.is-dot {
    width: 5px;
    height: 5px;
}
</style>
